package com.sweetlime.dungeonamigo.presentation.navigation

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class NavigationController {
    private val _requestedTab = MutableStateFlow<Int?>(null)
    val requestedTab: StateFlow<Int?> = _requestedTab.asStateFlow()

    fun requestTab(index: Int) { _requestedTab.value = index }
    fun consumeRequest() { _requestedTab.value = null }

    // Persists the last character ID opened so CompendiumScreen can pass it
    // to SpellDetailScreen when the user browses spells from the character context.
    private val _activeCharacterId = MutableStateFlow<String?>(null)
    val activeCharacterId: StateFlow<String?> = _activeCharacterId.asStateFlow()

    fun setActiveCharacter(characterId: String?) { _activeCharacterId.value = characterId }
}
